module.exports = __webpack_public_path__ + "static/media/living-conditions.20384a4e.png";